<template>
  <SettingsPagePanelHeader :showSubtitle="true">
    <template #title>{{ title }}</template>
    <template #right>
      <div v-if="isEditing">
        <FlatButton
          :class="$style.button"
          variant="secondary"
          v-if="isEditing"
          @click="handleCancel"
        >
          キャンセル
        </FlatButton>
        <FlatButton
          :class="$style.button"
          @click="handleSave"
          :disabled="isSaveButtonDisabled"
        >
          保存
        </FlatButton>
      </div>
      <template v-else>
        <div v-if="hasIntroductionMessage">
          <FlatButton :class="$style.button" @click="handleEdit">
            <template #icon>
              <IconPen :class="[$style.button__icon]" />
            </template>
            編集
          </FlatButton>
        </div>
      </template>
    </template>
  </SettingsPagePanelHeader>
</template>

<script setup lang="ts">
import IconPen from '@/components/icons/IconPen.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import { computed } from 'vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'

const props = defineProps<{
  isEditing: boolean
  isSaveButtonDisabled: boolean
  hasIntroductionMessage: boolean
}>()

const emit = defineEmits<{
  (event: 'edit'): void
  (event: 'save'): void
  (event: 'cancel'): void
}>()

const title = computed(() =>
  props.isEditing
    ? 'デフォルト初期チャットメッセージ | 編集中'
    : 'デフォルト初期チャットメッセージ'
)

const handleSave = (): void => {
  emit('save')
}

const handleEdit = (): void => {
  emit('edit')
}

const handleCancel = (): void => {
  emit('cancel')
}
</script>

<style lang="scss" module>
.button {
  &:nth-child(n + 2) {
    margin-left: 16px;
  }
}
</style>
